import { render, staticRenderFns } from "./OrderFabricRawFabricTypeTable.vue?vue&type=template&id=365e713c&scoped=true&"
import script from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e713c",
  null
  
)

export default component.exports